// Utilitários de validação para o formulário de login

/**
 * Valida os campos do formulário de login
 * @param {string} user - Nome de usuário
 * @param {string} password - Senha
 * @returns {Object} Objeto com isValid (boolean) e errors (object)
 */
export const validateLoginForm = (user, password) => {
  const errors = {};
  
  if (!user || !user.trim()) {
    errors.user = "Campo usuário é obrigatório";
  }
  
  if (!password || !password.trim()) {
    errors.password = "Campo senha é obrigatório";
  }
  
  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

/**
 * Verifica se todos os campos obrigatórios estão preenchidos
 * @param {string} user - Nome de usuário
 * @param {string} password - Senha
 * @returns {boolean} True se todos os campos estão preenchidos
 */
export const areFieldsFilled = (user, password) => {
  return user.trim() !== "" && password.trim() !== "";
};

